<template>
  <card dis-hover class="procedure-editor-history">
    <divider orientation="left">
      История изменений
    </divider>
    <inline-loader v-if="loading" :loading="loading" />
    <comments-list
      v-else-if="comments.length"
      :comments="comments"
    />
    <div class="ms-help ms-nodata" v-else>
      Последние действия отсутствуют
    </div>
  </card>
</template>

<script>
import InlineLoader from '@/components/loaders/inline-loader'
import CommentsList from '@/components/comments/comments-list'

export default {
  props: ['comments', 'loading'],
  components: {
    CommentsList,
    InlineLoader
  }
}
</script>

<style lang="less">
.procedure-editor-history {
  .ivu-divider {
    margin-top: 0 !important;
    margin-bottom: 16px !important;
  }

  .comments-container {
    max-height: calc(50vh);
    overflow: auto;
  }
}
</style>
